import React from 'react';
import styled from 'styled-components';
import Button from '../common/Button';

const HeroSection = styled.section`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 100px 0;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 80px 0;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    padding: 60px 0;
  }
`;

const HeroContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

const HeroContent = styled.div`
  flex: 1;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    text-align: center;
  }
`;

const HeroTitle = styled.h1`
  font-size: ${props => props.theme.fontSizes.mega};
  margin-bottom: 15px;
  color: ${props => props.theme.colors.secondaryColor};
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.fontSizes.xxxlarge};
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xxlarge};
  }
`;

const HeroSubtitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.xlarge};
  margin-bottom: 20px;
  color: ${props => props.theme.colors.primaryColor};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.large};
  }
`;

const HeroDescription = styled.p`
  font-size: ${props => props.theme.fontSizes.medium};
  margin-bottom: 30px;
  color: ${props => props.theme.colors.grey[600]};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.regular};
  }
`;

const HeroButtons = styled.div`
  display: flex;
  gap: 15px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    justify-content: center;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
    width: 80%;
    margin: 0 auto;
  }
`;

const HeroImage = styled.div`
  flex: 1;
  text-align: right;
  
  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: ${props => props.theme.shadows.regular};
  }
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    text-align: center;
  }
`;

const Hero = () => {
  return (
    <HeroSection>
      <div className="container">
        <HeroContainer>
          <HeroContent>
            <HeroTitle>Welcome to KSARC</HeroTitle>
            <HeroSubtitle>Structural Design Academy & Research Centre</HeroSubtitle>
            <HeroDescription>
              Excellence in Structural Engineering Education and Research
            </HeroDescription>
            <HeroButtons>
              <Button to="/tnpsc" variant="primary">
                TNPSC Exam Coaching
              </Button>
              <Button to="/contact" variant="secondary">
                Contact Us
              </Button>
            </HeroButtons>
          </HeroContent>
          <HeroImage>
            <img 
              src="/placeholder/600/building.png" 
              alt="KSARC Building" 
            />
          </HeroImage>
        </HeroContainer>
      </div>
    </HeroSection>
  );
};

export default Hero;
